interface LeadDisplayNameInput {
  fullName?: string | null;
  company?: string | null;
  email?: string | null;
  customFields?: Record<string, unknown> | null;
}

/**
 * A lead represents the contact person, not their company (FLOSEAI-531).
 * Leads created before the fullName fix stored the company in `fullName` and
 * the person only in `customFields.contactName`, so that field wins when
 * present; company and email are last-resort identifiers.
 */
export function getLeadDisplayName(lead: LeadDisplayNameInput | null | undefined): string | null {
  if (!lead) return null;

  const rawContactName = lead.customFields?.contactName;
  const contactName =
    typeof rawContactName === 'string' && rawContactName.trim() ? rawContactName.trim() : null;

  return contactName || lead.fullName?.trim() || lead.company?.trim() || lead.email?.trim() || null;
}
